import { Injectable } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// INTERFACES

// COMPONENTS
import { UiLoadingDialogComponent, UiMessageDialogComponent } from '../../../ui';

// CONFGS
import { DialogConfig } from '../../configs/dialog.config';

@Injectable({
  providedIn: 'root',
})
export class LoadingDialogUtilService {
  private onDestroy$ = new Subject();
  private dialogRef :MatDialogRef<UiLoadingDialogComponent>;

  constructor(private dialog :MatDialog) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  show(params :{ title ?:string; message ?:string } | string) :void {
    this.dialogRef = this.dialog.open(UiLoadingDialogComponent, {
      data: params,
      width: DialogConfig.sizes.small,
      disableClose: true,
    });

    this.dialogRef.afterClosed().pipe(takeUntil(this.onDestroy$)).subscribe();
  }

  showDialogMessage(params :{ title ?:string; message ?:string } | string) :void {
    this.dialog
      .open(UiMessageDialogComponent, {
        data: params,
        width: DialogConfig.sizes.small,
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe();
  }

  close() :void {
    this.dialogRef.close();
  }
}
